module.exports = __webpack_public_path__ + "static/google-play-fr-c83a05235b420bd055438b0b160fee50.png";